<template>
	<div class="about">
		<div class="pg-header">
			<div>
				<label class="title">肝癌筛查统计</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>统计管理</span>| <span>肝癌筛查统计</span>
				</div>
			</div>
		</div>
		<div class="top">
			<ScreenTable dataType="HBV"/>
		</div>
		<div class="bot">
			<ScreenTable dataType="HCV"/>
		</div>
	</div>
</template>

<script>
	import mixin from "@/views/mixin";
	import ScreenTable from './components/screenTable.vue';
	export default {
		mixins: [mixin],
		components:{ScreenTable},

		data() {
			return {
			
			};
		},
	
	
		methods: {
			
			
		},
	};
</script>

<style lang="less" scoped>
	@import "@/assets/style/var";
	// @import './sty.less';

</style>